<template>
  <div class="chat-messages p-4" v-if="messages?.length">

    <button
      class="btn text-right mb-2 btn-link shadow-none align-self-end"
      v-if="hasMore"
      @click="loadMore"
    >
      Load more...
    </button>

    <div
      class="pb-4 d-flex align-items-center"
      :class="[message.sender_id === profile.id ? 'chat-message-right' : 'chat-message-left']"
      :key="`message-${message.id}`"
      v-for="message of messages"
    >
      <div>
        <img
          :src="message.sender_id === profile.id ? profile.profile_image : coach.profile_image"
          class="rounded-circle mr-1"
          :alt="profile.first_name"
          width="40"
          height="40"
        />
      </div>
      <div class="flex-shrink-1 bg-light rounded py-2 px-3 mr-3">
        <div class="font-weight-bold mb-1">
          {{ message.sender_id === profile.id ? 'You' : `${coach.first_name} ${coach.last_name}` }}
        </div>
        {{ message.message }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    messages: Array,
    hasMore: Boolean,
    coach: Object
  },
  computed: {
    profile() {
      return this.$store.state.profile;
    },
  },
  methods: {
    loadMore() {
      this.$emit('loadMore')
    }
  }
}
</script>

<style scoped>

.chat-messages {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.chat-message-left,
.chat-message-right {
  display: flex;
  flex-shrink: 0
}

.chat-message-left {
  margin-right: auto
}

.chat-message-right {
  flex-direction: row-reverse;
  margin-left: auto
}
</style>
